import { assistantModuleManifest } from '../assistant.module.js';
import { assistantSettingRegistrations } from '../settings/assistant-setting-definitions.js';
export const assistantWebModuleContribution = {
    moduleId: 'assistant',
    manifest: assistantModuleManifest,
    settingRegistrations: assistantSettingRegistrations,
    settingEditors: [{
            id: 'assistant.web.settings.redaction-policy',
            moduleId: 'assistant',
            settingKey: 'assistant.context.redaction-policy',
            priority: 0,
            load: () => import('./assistant-redaction-policy-setting-editor.js'),
        }],
    hostContracts: [],
    hostContributions: [],
    routes: [{
            id: 'assistant.web.workspace', moduleId: 'assistant', path: '/assistant',
            requiredPermission: 'assistant.conversations.read',
            navigation: {
                id: 'assistant.navigation.workspace', fallbackLabel: 'Assistant',
                labelConfigurationKey: 'assistant.copy.workspace', labelValueProperty: 'navigationLabel',
                priority: 70,
            },
            load: () => import('./assistant-workspace.page.js'),
        }],
};
export default assistantWebModuleContribution;
//# sourceMappingURL=assistant-web.module-contribution.js.map